import React, { Fragment, useEffect, useState, forwardRef } from "react";
import { useAuth } from "../context/AuthContext";
import AsyncSelect from "react-select/async";

const MessageTypeSelection = forwardRef(({
  defaultValue,
  onSelected,
  placeholderText = "Select Message Type",
  disabled = false,
}, ref) => {
  const { authAxios } = useAuth();
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (defaultValue === null || defaultValue === undefined) return;
    setSelected({ value: defaultValue, label: defaultValue });
  }, [defaultValue]);

  const fetchMessageTypes = async () => {
    try {
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {},
      };

      const response = await authAxios().get(
        "/api/backoffice/messages/types",
        config,
      );
      
      // Map message types to react-select format
      const options = response.data.map(messageType => ({
        value: messageType,
        label: messageType
      }));
      
      return options;
    } catch (error) {
      console.log("Error fetching message types");
      console.log(error);
      console.log(error.stack);
    }
    return [];
  };

  const selectMessageType = (messageTypeOption) => {
    setSelected(messageTypeOption);
    onSelected(messageTypeOption?.value);
  };

  const promiseOptions = () =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(fetchMessageTypes());
      }, 300);
    });
  
  // Expose methods to the parent component via ref
  React.useImperativeHandle(ref, () => ({
    reset: () => {
      setSelected(null);
      onSelected(null);
    }
  }));

  return (
    <Fragment>
      <AsyncSelect
        className={"fs-input w-100"}
        cacheOptions
        loadOptions={promiseOptions}
        defaultOptions={true}
        isClearable={true}
        onChange={(data) => {
          selectMessageType(data);
        }}
        value={selected}
        placeholder={placeholderText}
        isDisabled={disabled}
      />
    </Fragment>
  );
});

export default MessageTypeSelection;
